import CloseIcon from "assets/icons/CloseIcon";
import clsx from "clsx";

type Props = {
    title?: string;
    description?: string;
    type: "warning" | "info"; // you can add type to change warning box ui
    extraViewClassName?: string;
    /**
     * use tailwind css style to change view style
     */
    extraTitleClassName?: string;
    /**
     * use tailwind css style to change title style
     */
    extraDescriptionClassName?: string;
    /**
     * use tailwind css style to change description style
     */
    onClose?: () => void;
};

const WarningBox = (props: Props) => {
    const {
        title,
        description,
        type,
        extraViewClassName,
        extraDescriptionClassName,
        extraTitleClassName,
        onClose,
    } = props;
    return (
        <div
            className={clsx(
                "flex flex-col px-4 py-3 rounded-md my-2",
                type === "warning" && "bg-[#FCF6E5]",
                type === "info" && "bg-[#E8F0FF]",
                extraViewClassName && extraViewClassName,
                !extraViewClassName && "w-full "
            )}
        >
            <div className="flex flex-row w-full items-center justify-between">
                <div className="flex flex-row items-center">
                    <InfoIcon type={type} className="ml-1"/>
                    <span
                        className={clsx(
                            !extraTitleClassName && "font-IRANSansMedium font-medium text-sm",
                            extraTitleClassName
                        )}
                    >
            {title}
          </span>
                </div>
                {onClose && (
                    <div onClick={() => onClose()} className="cursor-pointer">
                        <CloseIcon scale={0.5}/>
                    </div>
                )}
            </div>

            <p
                className={clsx(
                    extraDescriptionClassName,
                    !extraDescriptionClassName && "font-IRANSans font-light text-xs mt-3",
                    type === "info" && "text-[#424242]",
                    type === "warning" && "text-[#73726F]"
                )}
            >
                {description}
            </p>
        </div>
    );
};

export default WarningBox;

const infoColor = {
    warning: "#A8660D",
    info: "#1D4ED8",
    default: "#576271",
};

export const InfoIcon = ({
                             className,
                             type = "default",
                         }: {
    className?: string;
    type: "warning" | "info" | "default";
}) => (
    <div className={className}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 10.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 1 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75Zm0-1.125a1.125 1.125 0 1 0-1.123-1.127A1.123 1.123 0 0 0 12 9.373v.003ZM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-7.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Z"
                fill={infoColor[type]}
            />
        </svg>
    </div>
);
